export default __webpack_public_path__ + "static/media/monty.3ddbfc41.png";